import { render } from "./FooterNWI.vue?vue&type=template&id=e18fdf88&scoped=true"
import script from "./FooterNWI.vue?vue&type=script&lang=js"
export * from "./FooterNWI.vue?vue&type=script&lang=js"

import "./FooterNWI.vue?vue&type=style&index=0&id=e18fdf88&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2125467209/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e18fdf88"]])

export default __exports__